// extracted by mini-css-extract-plugin
export default {"matrixCanvas":"MatrixCanvas_matrixCanvas__8T8+b"};